module.exports = __webpack_public_path__ + "static/media/temp-upload-image.f72f08f7.png";